import { QUICK_RESPONSES } from '@nudge/shared';
import { useCardsStore } from '../../stores/cards';
import { toast } from '../ui/Toast';

export function QuickResponse({ sentCardId }: { sentCardId: string }) {
  const ackCard = useCardsStore((s) => s.ackCard);

  async function pick(text: string) {
    try {
      await ackCard(sentCardId, text);
    } catch (e) {
      toast(e instanceof Error ? e.message : 'Could not respond', 'error');
    }
  }

  return (
    <div className="mt-3 grid grid-cols-2 gap-2">
      {QUICK_RESPONSES.map((r) => (
        <button
          key={r}
          onClick={() => pick(r)}
          className="rounded-xl border border-border-subtle bg-card px-3 py-2 text-sm text-text-primary"
        >
          {r}
        </button>
      ))}
    </div>
  );
}
